export default "__VITE_ASSET__DuVp3dqO__"